/* eslint-disable @typescript-eslint/indent */
import { Container, Typography } from '@pwskills/rachnaui';
import React, { useContext } from 'react';
import KeyBenefitsCard from './KeyBenefitsCard';
import CategoryPageContext from '../../../context/CategoryPageContext';
import VideoComponent from '../VideoContainer';

const KeyBenfits = () => {
  const { categoryDetails } = useContext(CategoryPageContext);
  const categoryFeatures = categoryDetails?.categoryFeature;
  const description = categoryFeatures?.description;
  const categoryUSPs = categoryFeatures?.categoryUsp;
  const videoUrl = categoryFeatures?.videoUrl;

  return (
    <Container className="py-8 large:!pt-14 large:!pb-10 flex flex-col gap-6 medium:!px-8 large:!px-20">
      <div className="flex large:!gap-6 items-center">
        <div className="hidden large:!flex large:!h-[352px] flex-grow ">
          {videoUrl ? (
            <VideoComponent url={videoUrl} />
          ) : (
            categoryFeatures?.thumbnailImage?.url &&
            categoryFeatures?.thumbnailImage?.url.trim() !== '' && (
              <img
                src={`${categoryFeatures?.thumbnailImage?.url}`}
                width={629}
                height={374}
                className="!w-full hidden large:!block rounded-3xl"
                alt={`${categoryFeatures?.thumbnailImage?.altText}`}
                loading="lazy"
              />
            )
          )}
        </div>
        <div className="flex flex-col gap-6 medium:!gap-8 w-full large:!w-[628px]">
          <div>
            <Typography
              component="h2"
              variant="bold"
              className="text-gray-850 text-[24px] medium:!text-[32px] large:!text-[48px] font-inter !leading-[60px]"
            >
              Key Benefits For You
            </Typography>
          </div>

          <div>
            <Typography
              component="body-regular"
              variant="regular"
              className="text-gray-850 text-[16px] line-clamp-3"
            >
              {description}
            </Typography>
          </div>

          <div className="block large:!hidden">
            {videoUrl ? (
              <VideoComponent url={videoUrl} />
            ) : (
              categoryFeatures?.thumbnailImage?.url &&
              categoryFeatures?.thumbnailImage?.url.trim() !== '' && (
                <img
                  src={`${categoryFeatures?.thumbnailImage?.url}`}
                  className="!w-full !h-full"
                  alt={`${categoryFeatures?.thumbnailImage?.altText}`}
                  width={629}
                  height={374}
                  loading="lazy"
                />
              )
            )}
          </div>

          <div className="hidden large:!flex gap-6">
            {categoryUSPs?.slice(0, 2).map((category) => (
              <KeyBenefitsCard {...category} key={category._id} />
            ))}
          </div>
        </div>
      </div>
      <div className="hidden large:!flex flex-wrap gap-4 large:!gap-6">
        {categoryUSPs?.slice(2).map((category) => (
          <KeyBenefitsCard {...category} key={category._id} />
        ))}
      </div>
      <div className="flex large:!hidden flex-wrap gap-6 medium:!gap-4 large:!gap-6">
        {categoryUSPs?.map((category) => (
          <KeyBenefitsCard {...category} key={category._id} />
        ))}
      </div>
    </Container>
  );
};

export default KeyBenfits;
